import { createContext, FC, PropsWithChildren, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createContextualCan, useAbility } from '@casl/react'
import { getUser } from 'redux/store/user/getters'
import {
  ability,
  defineAbility,
  VendorsAbility
} from 'features/MyCommunity/Vendors/Abilities'
import { AnyAbility } from '@casl/ability'

export const VendorsAbilityContext = createContext<VendorsAbility>(ability)

const VendorsAbilityProvider: FC<PropsWithChildren> = ({ children }) => {
  const user = useSelector(getUser)

  const ability = useMemo(() => defineAbility(user), [user])

  return (
    <VendorsAbilityContext.Provider value={ability}>
      {children}
    </VendorsAbilityContext.Provider>
  )
}

export const useVendorsAbility = () =>
  useAbility<VendorsAbility>(VendorsAbilityContext)

export const Can = createContextualCan<AnyAbility>(
  VendorsAbilityContext.Consumer
)

export default VendorsAbilityProvider
